import React, { useEffect, useState } from 'react'
import { Bar,Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    LineElement,
    ArcElement,
    Title,
    Tooltip,
    Legend
  } from 'chart.js';
import moment from 'moment';

  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement, // And registered here
    PointElement, // And registered here
    LineElement,
    BarElement,
    ArcElement,
    Title,
    Tooltip,
    Legend
  );
const GraphBoxAPC = ({ statsApc }) => {
    const options = {
        responsive: true,
        plugins: {
          legend: {
            position: 'top',
          },
          title: {
            display: true,
            text: "Attestations delivrées par mois",
          },
        },
      };    
 const [ monthlyData,setMonthlyData ] = useState({
    labels: [],
    datasets: []
 });  
 const [yearlyData,setYearlyData ] = useState({
    labels: [],
    datasets: []
 })
 const getData = () => {
   if( Array.isArray(statsApc?.monthlyStats) && statsApc?.monthlyStats.length > 0 ){ 
        setMonthlyData ({
            labels: statsApc?.monthlyStats.map((p) => {
            const mois = moment().month(p.month - 1).format('MMMM');
            return mois.charAt(0).toUpperCase()+ mois.slice(1).toLowerCase();
            }),
            datasets: [
            {
                label: "Attestations delivrées",
                backgroundColor: [
                'rgba(255, 99, 132, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(255, 159, 64, 0.2)',
                ],
                borderColor: [
                'rgba(255, 99, 132, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)',
                ],
                borderWidth: 1,
                hoverBackgroundColor: 'rgba(75,192,192,0.4)',
                hoverBorderColor: 'rgba(75,192,192,1)',
                data: statsApc?.monthlyStats?.map((p) => {
                return p.count;
            }),
            },
            ],
        });
   }
   if( Array.isArray(statsApc?.yearlyEvolution) && statsApc?.yearlyEvolution.length > 0 ){
    setYearlyData({
        labels: statsApc?.yearlyEvolution.map(item => item.year.toString()),
        datasets: [
          {
            label: 'Nombre d\'attestations',
            data: statsApc?.yearlyEvolution.map(item => item.count),
            borderColor: 'rgb(75, 192, 192)',
            backgroundColor: 'rgba(75, 192, 192, 0.2)',
            tension: 0.1,
            fill: true,
            pointBackgroundColor: 'rgb(75, 192, 192)',
            pointBorderColor: '#fff',
            pointHoverRadius: 5,
            pointHoverBackgroundColor: 'rgb(75, 192, 192)',
            pointHoverBorderColor: 'rgba(220,220,220,1)',
            pointHitRadius: 10,
            pointBorderWidth: 2,
          }
        ]
      });
    }
  } 
 useEffect(() => {
    getData();
 },[statsApc?.monthlyStats]);
  return (
    <div className="chart-and-array">
       <div className="chart">
          <Bar 
            data={monthlyData} 
            width={800}
            height={520}
            options={options} 
         />
         
        </div>
        <div className="chart">
            <Line data={yearlyData} 
              width={800}
              height={520}
           />
        </div>
    </div>
  )
}

export default GraphBoxAPC
